module.exports = __webpack_public_path__ + "img/for_help.dd6102ab.svg";